(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["maku-system"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maku-section')) {
  class MakuSection extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.desktop = matchMedia('(min-width: 1000px)');
      this.animations = new Set();
      this.motion = this.dataset.motion === 'true' && !window.Shopify?.designMode;
      this.setupReveal();
      this.setupMedia();
      this.setupSliders();
      this.addEventListener('shopify:block:select', event => {
        const block = event.target.closest('.mku-benefit, .mku-collection');
        if (block) block.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
      }, { signal: this.abort.signal });
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) this.animations.forEach(animation => animation.cancel());
        this.updateZoom();
        this.updateVideo();
      }, { signal: this.abort.signal });
    }
    setupReveal() {
      if (!this.motion || this.reduced.matches || !('IntersectionObserver' in window)) return;
      this.revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.revealObserver.unobserve(entry.target);
          if (this.reduced.matches) return;
          const animation = entry.target.animate([
            { opacity: 0, transform: 'translateY(24px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 760, easing: 'cubic-bezier(.16,1,.3,1)', delay: Number(entry.target.dataset.delay || 0) });
          this.animations.add(animation);
          animation.finished.then(() => this.animations.delete(animation)).catch(() => this.animations.delete(animation));
        });
      }, { threshold: .08 });
      this.querySelectorAll('[data-mku-reveal]').forEach(element => this.revealObserver.observe(element));
    }
    setupMedia() {
      this.zoomMedia = [...this.querySelectorAll('[data-mku-zoom]')];
      this.videos = [...this.querySelectorAll('video')];
      this.videos.forEach(video => { video.muted = true; video.defaultMuted = true; video.playsInline = true; });
      const schedule = () => {
        if (this.frame || !this.inView) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.updateZoom(); });
      };
      this.mediaObserver = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (this.inView) schedule();
        this.updateVideo();
      }, { rootMargin: '120px' });
      this.mediaObserver.observe(this);
      if (this.motion && this.zoomMedia.length) window.addEventListener('scroll', schedule, { passive: true, signal: this.abort.signal });
      this.desktop.addEventListener('change', () => this.updateZoom(), { signal: this.abort.signal });
      document.addEventListener('visibilitychange', () => this.updateVideo(), { signal: this.abort.signal });
      this.querySelectorAll('[data-mku-video-control]').forEach(button => {
        button.addEventListener('click', () => {
          this.videoPaused = !this.videoPaused;
          button.textContent = this.videoPaused ? button.dataset.play : button.dataset.pause;
          button.setAttribute('aria-pressed', String(this.videoPaused));
          this.updateVideo();
        }, { signal: this.abort.signal });
      });
    }
    updateZoom() {
      if (!this.zoomMedia?.length) return;
      if (!this.motion || this.reduced.matches || !this.desktop.matches) {
        this.zoomMedia.forEach(element => element.style.removeProperty('--mku-zoom'));
        return;
      }
      this.zoomMedia.forEach(element => {
        const bounds = element.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (innerHeight - bounds.top) / (innerHeight + bounds.height)));
        element.style.setProperty('--mku-zoom', String(1.07 - progress * .07));
      });
    }
    updateVideo() {
      this.videos?.forEach(video => {
        if (this.videoPaused || this.reduced.matches || !this.inView || document.hidden) video.pause();
        else video.play().catch(() => {});
      });
    }
    setupSliders() {
      this.querySelectorAll('[data-mku-slider]').forEach(slider => {
        const controls = this.querySelector('[data-mku-controls]');
        if (!controls) return;
        const previous = controls.querySelector('[data-previous]');
        const next = controls.querySelector('[data-next]');
        const update = () => {
          const max = slider.scrollWidth - slider.clientWidth;
          controls.hidden = max < 8;
          previous.disabled = slider.scrollLeft < 8;
          next.disabled = slider.scrollLeft >= max - 8;
        };
        [previous, next].forEach((button, index) => button.addEventListener('click', () => {
          const child = slider.firstElementChild;
          const gap = parseFloat(getComputedStyle(slider).columnGap) || 16;
          slider.scrollBy({ left: (child.getBoundingClientRect().width + gap) * (index ? 1 : -1), behavior: this.reduced.matches ? 'auto' : 'smooth' });
        }, { signal: this.abort.signal }));
        slider.addEventListener('scroll', update, { passive: true, signal: this.abort.signal });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(slider);
        update();
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.revealObserver?.disconnect();
      this.mediaObserver?.disconnect();
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.animations?.forEach(animation => animation.cancel());
    }
  }
  customElements.define('maku-section', MakuSection);
}
  } catch(e) { console.error(e); }
})();

})();
